import { t } from 'i18next';
import * as Yup from 'yup';

export const grantAccessValidationSchema = Yup.object({
  email: Yup.string().required(t('required')).email(t('invalidFormat')),
});
